import type { JobStatus } from '@godrop/types';
import { Badge } from './badge';

const map: Record<JobStatus, 'open' | 'accepted' | 'completed' | 'cancelled' | 'expired'> = {
  open: 'open',
  accepted: 'accepted',
  completed: 'completed',
  cancelled: 'cancelled',
  expired: 'expired',
};

export function StatusChip({ status }: { status: JobStatus }) {
  return <Badge variant={map[status]}>{status}</Badge>;
}
